import { render, staticRenderFns } from "./TabDocumenten.vue?vue&type=template&id=6a536034"
import script from "./TabDocumenten.vue?vue&type=script&lang=js"
export * from "./TabDocumenten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports